import 'whatwg-fetch'
const env = process.env;

const getBoardComponent = (data) => {
    return fetch(`${env.VUE_APP_trimaster}/api/v1/boardComponents/${data.id}?access_token=${data.apitoken}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    })
}

const getBoardComponentTypes = (data) => {
    return fetch(`${env.VUE_APP_trimaster}/api/v1/boardComponentTypes?access_token=${data.apitoken}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    })
}

const storeBoardComponent = (data) => {
    
    let post = {
        "boardComponentType_id": data.payload.boardComponentType_id || 0,
        "controller_id": data.payload.controller_id || 0,
        "name": data.payload.name || "",
        "addresspath": data.payload.addresspath || "0",
        "port": data.payload.port || null,
        "ports": data.payload.ports || null
    }

    return fetch(`${env.VUE_APP_trimaster}/api/v1/boardComponents?access_token=${data.apitoken}`, {
        method: 'POST',
		headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
		},
		body: JSON.stringify(post)
    })
}

const updateBoardComponent = (data) => {

    let put = {
        "id": data.payload.id || data.id,
        "boardComponentType_id": data.payload.boardComponentType_id || 0,
        "controller_id": data.payload.controller_id || 0,
        "name": data.payload.name || "",
        "addresspath": data.payload.addresspath || "0",
        "port": data.payload.port || null,
        "ports": data.payload.ports || 0
    }

    return fetch(`${env.VUE_APP_trimaster}/api/v1/boardComponents/${data.id}?access_token=${data.apitoken}`, {
        method: 'PUT',
		headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
		},
		body: JSON.stringify(put)
    })
}

export default {
    getBoardComponent,
    getBoardComponentTypes,
    storeBoardComponent,
    updateBoardComponent
}
